export const appVersion = "v1.5.5";
export const insightsProductCode = "451590000";
export const patientPathProductCode = "451570500";
